import ApiClient from '../ApiClient';
import User from '../models/User';
import ErrorResponse from '../types/ErrorResponse';
import ItemResponse from '../types/ItemResponse';

class AuthService extends ApiClient {
	async login(
		name: string,
		password: string,
		onSuccess: (response: ItemResponse<User>) => void,
		onError: (response: ErrorResponse) => void = () => {},
	) {
		await this.client
			.post('/auth/login', {
				name: name,
				password: password,
			})
			.then((response: any) => {
				onSuccess(response);
			})
			.catch(onError);
	}

	async me(
		onSuccess: (response: ItemResponse<User>) => void,
		onError: (error: ErrorResponse) => void = () => {},
	) {
		await this.client
			.get('/auth/me')
			.then((response: any) => {
				onSuccess(response);
			})
			.catch(onError);
	}

	async logout(onSuccess: () => void, onError: (response: ErrorResponse) => void = () => {}) {
		await this.client
			.post('/auth/logout')
			.then(() => {
				onSuccess();
			})
			.catch(onError);
	}
}

export default AuthService;
